import { e as d } from "./class-map-3ADKve8g.js";
import { P as m, b as n, n as o, t as k } from "./element-CV9utnHJ.js";
import { r as b } from "./state-l4hGZdFJ.js";
import { P as y } from "./pkt-slot-controller-D7CrjM52.js";
import { e as g, n as f } from "./ref-Dma3n3i8.js";
import "./icon-D0IQAVwS.js";
import { o as u } from "./if-defined-rXcLNTzN.js";
const $ = { size: { default: "medium" }, skin: { default: "blue" }, closeTag: { default: !1 }, type: { default: "button" } }, l = {
  props: $
};
var _ = Object.defineProperty, S = Object.getOwnPropertyDescriptor, e = (s, i, p, a) => {
  for (var r = a > 1 ? void 0 : a ? S(i, p) : i, c = s.length - 1, h; c >= 0; c--)
    (h = s[c]) && (r = (a ? h(i, p, r) : h(r)) || r);
  return a && r && _(i, p, r), r;
};
let t = class extends m {
  constructor() {
    super(), this.defaultSlot = g(), this.closeTag = l.props.closeTag.default, this.size = l.props.size.default, this.skin = l.props.skin.default, this.textStyle = null, this.iconName = void 0, this.type = l.props.type.default, this.ariaLabel = null, this.buttonTabindex = void 0, this._isClosed = !1, this._ariaDescription = null, this.close = (s) => {
      this._isClosed = !0, this.dispatchEvent(
        new CustomEvent("close", { detail: { origin: s }, bubbles: !1, composed: !0 })
      ), this.dispatchEvent(
        new CustomEvent("on-close", { detail: { origin: s }, bubbles: !1, composed: !0 })
      );
    }, this.slotController = new y(this, this.defaultSlot), this._isClosed = !1;
  }
  /**
   * Lifecycle
   */
  firstUpdated(s) {
    var i, p;
    if (super.firstUpdated(s), this.closeTag && !this.ariaLabel) {
      const a = (p = (i = this.defaultSlot.value) == null ? void 0 : i.textContent) == null ? void 0 : p.trim();
      a && (this._ariaDescription = `Klikk for å fjerne ${a}`);
    }
  }
  render() {
    const s = {
      "pkt-tag": !0,
      [`pkt-tag--${this.size}`]: !!this.size,
      [`pkt-tag--${this.skin}`]: !!this.skin,
      [`pkt-tag--${this.textStyle}`]: !!this.textStyle
    }, i = {
      "pkt-tag": !0,
      "pkt-btn": !0,
      "pkt-btn--tertiary": !0,
      [`pkt-tag--${this.textStyle}`]: !!this.textStyle,
      [`pkt-tag--${this.size}`]: !!this.size,
      [`pkt-tag--${this.skin}`]: !!this.skin,
      "pkt-btn--icons-right-and-left": this.closeTag && !!this.iconName,
      "pkt-hide": this._isClosed
    };
    return this.closeTag ? n`
        <button
          class=${d(i)}
          type=${this.type}
          tabindex=${u(this.buttonTabindex)}
          @click=${this.close}
          aria-label=${u(this.ariaLabel || void 0)}
          aria-description=${u(this._ariaDescription || void 0)}
        >
          ${this.iconName && n`<pkt-icon
            class="pkt-tag__icon"
            name=${this.iconName}
            aria-hidden="true"
          ></pkt-icon>`}
          <span ${f(this.defaultSlot)}></span>
          <pkt-icon class="pkt-tag__close-btn" name="close"></pkt-icon>
        </button>
      ` : n`
        <span class=${d(s)}>
          ${this.iconName && n`<pkt-icon
            class="pkt-tag__icon"
            name=${this.iconName}
            aria-hidden="true"
          ></pkt-icon>`}
          <span ${f(this.defaultSlot)}></span>
        </span>
      `;
  }
};
e([
  o({ type: Boolean, reflect: !0 })
], t.prototype, "closeTag", 2);
e([
  o({ type: String, reflect: !0 })
], t.prototype, "size", 2);
e([
  o({ type: String, reflect: !0 })
], t.prototype, "skin", 2);
e([
  o({ type: String, reflect: !0 })
], t.prototype, "textStyle", 2);
e([
  o({ type: String, reflect: !0 })
], t.prototype, "iconName", 2);
e([
  o({ type: String })
], t.prototype, "type", 2);
e([
  o({ type: String })
], t.prototype, "ariaLabel", 2);
e([
  o({ type: Number, attribute: "button-tabindex" })
], t.prototype, "buttonTabindex", 2);
e([
  b()
], t.prototype, "_isClosed", 2);
e([
  b()
], t.prototype, "_ariaDescription", 2);
t = e([
  k("pkt-tag")
], t);
export {
  t as P
};
